module.exports = __webpack_public_path__ + "img/benefit_card_image_5.446fa21d.png";